export const apiBaseUrl = 'https://api.kgprodesign.com/kgpro/wp-json';

// Get blog name from environment variable, default to 'Blog' if not set
export const blogName = import.meta.env.VITE_BLOG_NAME || 'Blog';

// Convert blog name to URL-friendly slug
export const blogSlug = blogName.toLowerCase().replace(/\s+/g, '-'); 